import { faHeart } from '@fortawesome/free-solid-svg-icons'
const [ size,,,, heart ] = faHeart.icon

const range = (a, b) => (b - a) * Math.random() + a

class Confetti {
  constructor ({ canvas, colors }) {
    this.canvas = canvas
    this.style = colors[~~range(0, colors.length)]
    this.r = ~~range(2, 6)
    this.r2 = 2 * this.r
    this.scale = this.r / 60
    this.xmin = -this.scale * size
    this.tr = this.scale * size / 2
    this.xmax = this.canvas.width - this.r
    this.ymax = this.canvas.height - this.r
    this.replace()
  }

  replace () {
    const offsetY = this.canvas.height / 2
    this.opacity = 0
    this.dop = 0.001 * range(1, 4)
    this.x = range(-this.r2, this.canvas.width - this.r2)
    this.y = range(-offsetY, offsetY)
    this.vx = range(0, 2) + 8 * this.canvas.xpos - 5
    this.vy = 0.3 * this.r + range(-1, 1)
    this.angle = 0.3 * range(-1, 1)
    this.da = 0.001 * range(-1, 1)
  }

  draw () {
    this.x += this.vx
    this.y += this.vy
    this.opacity += this.dop
    if (this.opacity > 1) {
      this.opacity = 1
      this.dop *= -1
    }
    if (this.opacity < 0 || this.y > this.ymax)
      this.replace()
    if (this.xmin > this.x)
      this.x = this.xmax
    else if (this.x > this.xmax)
      this.x = this.xmin
    this.angle += this.da
  }
}

export const init = (canvas, { colors }) => {
  const context = canvas.getContext('2d')
  let numConfetti = canvas.offsetWidth / 12
  let running = true

  canvas.xpos = 0.5
  const handleMouseMove = e => {
    if (e.pageX >= canvas.offsetLeft && e.pageX <= canvas.offsetLeft + canvas.width)
      canvas.xpos = (e.pageX - canvas.offsetLeft) / canvas.width
  }
  if (canvas.doMouseStuff)
    document.addEventListener('mousemove', handleMouseMove)

  const setCanvasSize = () => {
    canvas.width = canvas.offsetWidth
    canvas.height = canvas.offsetHeight
  }
  setCanvasSize()

  const handleResize = () => {
    if (canvas.width == canvas.offsetWidth && canvas.height == canvas.offsetHeight)
      return

    setCanvasSize()
    stop()
    init(canvas, { colors })
  }
  const resizeObserver = new ResizeObserver(handleResize)
  resizeObserver.observe(canvas)

  const stop = () => {
    running = false
    document.removeEventListener('mousemove', handleMouseMove)
    resizeObserver.disconnect()
  }

  const drawCircle = circle => {
    circle.draw()
    const path = new Path2D(heart)
    context.translate(~~circle.x + circle.tr, ~~circle.y + circle.tr)
    context.rotate(circle.angle)
    context.translate(-circle.tr, -circle.tr)
    context.scale(circle.scale, circle.scale)
    context.fillStyle = `rgba(${circle.style.concat(circle.opacity).join()})`
    context.fill(path)
    context.strokeStyle = `rgba(255,255,255,${Math.min(circle.opacity * 2, 1)})`
    context.lineWidth = 20
    context.lineCap = 'round'
    context.stroke(path)
    context.setTransform(1, 0, 0, 1, 0, 0)
  }

  const step = () => {
    context.clearRect(0, 0, canvas.width, canvas.height)
    if (running) {
      confetti.forEach(drawCircle)
      requestAnimationFrame(step)
    }
  }

  const confetti = []
  for (let i = 1; i <= numConfetti; i++) {
    confetti.push(new Confetti({ canvas, colors }))
  }
  step()

  return stop
}

